import { render, staticRenderFns } from "./events-limit-notice.vue?vue&type=template&id=737802a4&scoped=true&"
import script from "./events-limit-notice.vue?vue&type=script&lang=ts&"
export * from "./events-limit-notice.vue?vue&type=script&lang=ts&"
import style0 from "./events-limit-notice.vue?vue&type=style&index=0&id=737802a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737802a4",
  null
  
)

export default component.exports